type Mask =
  | "CPF"
  | "cpf"
  | "CNPJ"
  | "cnpj"
  | "celular"
  | "telefone"
  | "dinheiro"
  | "data"
  | "dataStr"
  | "cep"
  | "money-brl"
  | undefined;

export const maskHandler = (mask: Mask, value: string): string => {
  switch (mask) {
    case "data":
      return value
        .toString()
        .replace(/\D/g, "")
        .replace(/(\d{1,8}).*/, "$1")
        .replace(/(\d{2})(\d{2})/, "$1/$2")
        .replace(/(\d{2})(\d{2,4})/, "$1/$2");
    case "CPF":
      return value
        .toString()
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, "$1");
    case "CNPJ":
      return value
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, "$1");
    case "celular":
      return value
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d)/g, "($1) $2")
        .replace(/(\d{5})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{4})\d+?$/, "$1");
    case "telefone":
      return value
        .replace(/\D/g, "")
        .replace(/^(\d{2})(\d)/g, "($1) $2")
        .replace(/(\d{4})(\d{1,2})/, "$1-$2")
        .replace(/(-\d{4})\d+?$/, "$1");
    case "dinheiro": {
      const newValue = value.toString();
      return `R$ ${newValue
        .replace(/\D/g, "")
        .replace(/(\d{6})\d+?$/, "$1")
        .toLocaleString()}`;
    }
    case "cep":
      return value
        .replace(/\D/g, "")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{3})\d+?$/, "$1");
    default:
      return value;
  }
};

export const maskRemover = (value: string): string => {
  const regexCharacter = /[-./()]/g;
  const regexSpaces = /\s+/g;

  return value.replace(regexCharacter, "").replace(regexSpaces, "").replace("R$", "");
};
